module.exports = __webpack_public_path__ + "fonts/helvetica_bold_oblique.28068c1.ttf";